import React from "react";
import { ArrowDownRight, MapPin, Sparkles } from "lucide-react";

const HERO_IMAGE =
  "https://customer-assets.emergentagent.com/job_stac-detail-book/artifacts/a3qzfok9_IMG_0518.jpeg";

export default function Hero() {
  return (
    <section id="top" data-testid="hero-section" className="relative min-h-[100svh] w-full overflow-hidden">
      {/* Background image */}
      <div
        className="absolute inset-0 bg-cover bg-center"
        style={{ backgroundImage: `url('${HERO_IMAGE}')` }}
      />
      <div className="absolute inset-0 bg-gradient-to-b from-black/60 via-black/55 to-[#0A0A0A]" />
      <div className="absolute inset-0 bg-[radial-gradient(ellipse_at_top_right,rgba(255,255,255,0.06),transparent_50%)]" />

      {/* Content */}
      <div className="relative z-10 px-6 md:px-12 lg:px-20 pt-36 md:pt-44 pb-24 min-h-[100svh] flex flex-col">
        <div className="overline mb-8 fade-up" data-testid="hero-overline">
          <span className="inline-block w-8 h-px bg-white/50 mr-3 align-middle" />
          Premium Mobile Detailing · Est. 2025
        </div>

        <a
          href="#services"
          data-testid="hero-first-wash-pill"
          className="inline-flex self-start items-center gap-2 border border-emerald-300/40 bg-emerald-300/10 hover:bg-emerald-300/20 transition-colors px-4 py-2 mb-8 text-[11px] tracking-[0.2em] uppercase text-emerald-200 fade-up"
          style={{ animationDelay: "0.05s" }}
        >
          <Sparkles size={12} /> 50% off your first wash
        </a>

        <h1
          data-testid="hero-headline"
          className="font-display text-5xl sm:text-6xl lg:text-8xl font-light tracking-tighter leading-[0.95] max-w-5xl fade-up"
          style={{ animationDelay: "0.1s" }}
        >
          The showroom shine,
          <br />
          <span className="text-white/60">brought to your doorstep.</span>
        </h1>

        <p
          className="mt-10 max-w-xl text-base sm:text-lg text-white/70 leading-relaxed fade-up"
          style={{ animationDelay: "0.25s" }}
          data-testid="hero-subtitle"
        >
          St Auto Care is a premium mobile detailing service. We come fully equipped to your home or
          workplace and treat every vehicle like it&apos;s our own.
        </p>

        <div className="mt-12 flex flex-col sm:flex-row gap-4 fade-up" style={{ animationDelay: "0.4s" }}>
          <a
            href="#book"
            data-testid="hero-book-cta"
            className="group inline-flex items-center justify-between gap-6 bg-white text-black hover:bg-white/90 transition-colors duration-300 px-7 py-4 text-xs font-medium tracking-[0.22em] uppercase"
          >
            Book An Appointment
            <ArrowDownRight size={18} className="transition-transform group-hover:translate-x-1 group-hover:translate-y-1" />
          </a>
          <a
            href="#services"
            data-testid="hero-services-cta"
            className="inline-flex items-center justify-center gap-3 bg-transparent border border-white/25 text-white hover:border-white/70 hover:bg-white/5 transition-all duration-300 px-7 py-4 text-xs font-medium tracking-[0.22em] uppercase"
          >
            View Services
          </a>
        </div>

        <div
          className="mt-auto pt-20 grid grid-cols-2 md:grid-cols-4 gap-8 text-left fade-up"
          style={{ animationDelay: "0.55s" }}
          data-testid="hero-stats"
        >
          {[
            { k: "Mobile", v: "We come to you" },
            { k: "West Midlands", v: "& nationwide" },
            { k: "Premium", v: "Pro-grade products" },
            { k: "5★", v: "Customer-rated" },
          ].map((s) => (
            <div key={s.k} className="border-t border-white/15 pt-4">
              <div className="font-display text-2xl font-light">{s.k}</div>
              <div className="text-xs text-white/55 mt-1 tracking-wide">{s.v}</div>
            </div>
          ))}
        </div>

        <div className="absolute bottom-6 right-6 md:right-12 hidden md:flex items-center gap-2 text-xs text-white/50 tracking-widest uppercase">
          <MapPin size={14} /> West Midlands · UK
        </div>
      </div>
    </section>
  );
}
